// Base language (English). Other languages live next to this file and must
// have the same keys.
export const en = {
  "tabs.transfer": "Transfer",
  "tabs.convert": "Convert points",
  "tabs.history": "History",

  "convert.pointsAvailable": "Agency points",
  "convert.coinsStock": "Coins Trading",
  "convert.rateTitle": "Conversion rate",
  "convert.rateLine": "{points} points = {coins} coins",
  "convert.ratePerCoin": "1 coin = {perCoin} points",
  "convert.amountLabel": "* Coins to receive",
  "convert.amountPlaceholder": "Enter the coins amount",
  "convert.max": "Max",
  "convert.cost": "You will spend {points} points",
  "convert.limits": "Minimum {min} coins · maximum now {max} coins",
  "convert.packagesLabel": "* Choose a package",
  "convert.packageLine": "{points} points → {coins} coins",
  "convert.packageNotEnough": "Not enough points",
  "convert.packagesHint": "Conversions only in ready-made packages (minimum {min} coins).",
  "convert.error.invalid_package": "Choose one of the ready-made packages.",
  "convert.button": "Convert",
  "convert.sending": "Converting...",
  "convert.confirmTitle": "Confirm conversion",
  "convert.confirmCoins": "You receive",
  "convert.confirmPoints": "You spend",
  "convert.confirmRate": "Rate",
  "convert.confirmPointsAfter": "Points after",
  "convert.confirmCoinsAfter": "Coins Trading after",
  "convert.coinsUnit": "{value} coins",
  "convert.pointsUnit": "{value} points",
  "convert.cancel": "Cancel",
  "convert.confirm": "Confirm",
  "convert.success": "Converted: {points} points → {coins} coins added to your Coins Trading.",
  "convert.loading": "Loading your balance...",

  "convert.error.below_minimum": "The minimum conversion is {min} coins.",
  "convert.error.invalid_coins": "Enter a whole number of coins, greater than zero.",
  "convert.error.not_enough_points": "Not enough agency points for this amount. Nothing was changed.",
  "convert.error.agency_not_found": "This account is not the owner of a reseller agency.",
  "convert.error.conversion_rate_unavailable": "The conversion rate is not available right now. Contact support.",
  "convert.error.invalid_token": "Your session expired. Log in again.",
  "convert.error.user_moderation_cannot_use_monetization": "Your account is not allowed to convert right now.",
  "convert.error.generic": "Could not convert. Nothing was changed — check your connection and try again.",

  "history.summary.title": "Total of this list",
  "history.summary.line": "{coins} coins sold · {count} sales",
  "history.summary.reversedLine": "Reversed (not counted): {coins} coins · {count} sales",
  "history.summary.loading": "Calculating total...",
  "history.filter.all": "All sales",
  "history.filter.user": "Buyer ID {id}",
  "history.filter.from": "from {date}",
  "history.filter.to": "until {date}",
  "history.download.xlsx": "Excel (.xlsx)",
  "history.download.pdf": "PDF",
  "history.download.working": "Preparing file...",
  "history.download.done": "File downloaded: {count} sales.",
  "history.download.error": "Could not create the file. Try again.",
  "history.export.title": "Sales history",
  "history.export.filter": "Filter",
  "history.export.truncated": "Only the newest {limit} sales are in this file.",
  "history.export.colDate": "Date",
  "history.export.colSaleId": "Sale ID",
  "history.export.colBuyerId": "Buyer ID",
  "history.export.colBuyerName": "Buyer name",
  "history.export.colType": "Type",
  "history.export.colCoins": "Coins",
  "history.export.colValue": "Value (R$)",
  "history.export.period": "Period",
  "history.export.priceLine": "Value at R$ 1 = {coins} coins",
  "history.export.generatedAt": "Generated on {date}",
  "history.export.sheetName": "Sales",
  "history.export.totalsLabel": "TOTAL (sold)",
  "history.export.totalsHint": "Reversed sales not counted",
  "history.export.salesUnit": "sales",
  "history.summary.salesCount": "{count} sales",
  "history.summary.valueLine": "≈ {value}",
  "history.list.totalsTitle": "Total of the filter",
  "history.kind.sale": "Sale",
  "history.kind.reversal": "Reversal",
  "history.kind.conversion": "Conversion",
  "history.kind.other": "Other movement",
  "history.kind.unrecorded": "Unrecorded change",
  "history.export.colCoinsSold": "Coins sold",
  "history.export.colMovement": "Stock movement",
  "history.export.colPoints": "Points spent",
  "history.export.colBalance": "Balance after",
  "history.export.statusReversalOf": "Sale #{id} reversed (coins back to stock)",
  "history.export.statusConversion": "{points} points converted",
  "history.export.statusUnrecorded": "Stock changed without a ledger record (e.g. conversion made elsewhere)",
  "history.export.opening": "Opening balance (Coins Trading)",
  "history.export.closing": "Closing balance (Coins Trading)",
  "history.export.totalsSales": "SALES (sold)",
  "history.export.totalsConversions": "CONVERSIONS",
  "history.export.totalsMovement": "ALL MOVEMENTS",
  "history.export.check": "CHECK (opening + movements − closing)",
  "history.export.checkLine": "{opening} {movement} = {closing}",
  "history.summary.conversionsCount": "{count} conversions",
  "history.summary.conversionsLine": "Converted: {coins} coins · {count} conversions",
  "history.summary.balanceLine": "Coins Trading: {opening} → {closing}",
  "history.row.conversion": "+{coins} coins · −{points} points",
  "history.row.reversalOf": "Sale #{id} reversed",
  "history.row.balance": "Balance {value}",
  "history.row.unrecorded": "Stock changed without a record",
  "history.export.colStatus": "Status",
  "history.export.typeUser": "User",
  "history.export.typeAgent": "Agent",
  "history.export.statusSold": "Sold",
  "history.export.statusReversed": "Reversed on {date}",
} as const;

export type MessageKey = keyof typeof en;
